import { BackendPaths, UserRoles } from '@/lib/utils';

export interface OnboardingEntityPayload {
  masterDataItemId: string;
  value: string;
}

export interface UpdateEntityRequest {
  type: UpdateEntityType;
  attributes: OnboardingEntityPayload[];
}

export interface KYCVerifyPayload {
  organizationId: string;
  emailId: string;
  director_id: string;
}

export interface VerifyAccountPayload {
  accountName: string;
  accountNumber: string;
  bsb: string;
  bankName: string;
  branch: string;
}

export enum RegisterationStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
}
export interface RegisterationStatusResponse {
  onboardingQuestion: RegisterationStatus;
  termsAndCondition: RegisterationStatus;
  creditLimitOverview: RegisterationStatus;
  abnVerification: RegisterationStatus;
  bankDetailsVerification: RegisterationStatus;
  kycStatus: RegisterationStatus;
  openBankingConnection?: RegisterationStatus;
  estimatedCreditLimit?: RegisterationStatus;
  approvedCreditLimit?: RegisterationStatus;
  uploadBusinessDocument?: RegisterationStatus;
  extras: {
    roles: UserRoles;
    abnHint: string;
  };
}

export interface KycDocumentPayload {
  front: File;
  rear: File;
  selfie: File;
}

export interface ExternalKycDocumentPayload {
  x_kyc_token: string;
  front: File;
  rear: File;
  selfie: File;
}

export enum UpdateEntityType {
  Tnc = 'termsAndCondition',
  CustomerTnc = 'customerTermsAndCondition',
  Questionnaire = 'questionnaire',
  Pricing = 'pricing',
}

export const endpointMap: Record<UpdateEntityType, string> = {
  [UpdateEntityType.Tnc]: BackendPaths.TNC,
  [UpdateEntityType.CustomerTnc]: BackendPaths.CUSTOMERTNC,
  [UpdateEntityType.Questionnaire]: BackendPaths.QUESTIONNAIRE,
  [UpdateEntityType.Pricing]: BackendPaths.PRICING,
};

export interface ExchangePlaidTokenPayload {
  publicToken: string;
}

export interface CompanyDocumentPayload {
  coi: File;
  byLaws: File;
  boardResolution: File;
}

export interface CompanyDocUploadResponse {
  presidentName: string;
  companyName: string;
  companyAddress: string;
}

export interface CreateWithEinPayload {
  businessName: string;
  ein: string;
  presidentName: string;
  companyAddress: string;
}
